import { UntitledIcon } from '@faceup/icons'
import { ulChevronDown } from '@faceup/icons/ulChevronDown'
import { ulChevronUp } from '@faceup/icons/ulChevronUp'
import { InputNumber as AntInputNumber, type InputNumberProps as AntInputNumberProps } from 'antd'

export type InputNumberProps = AntInputNumberProps

export const InputNumber = (props: AntInputNumberProps) => {
  const iconSize = props.size === 'small' ? 11 : 13

  return (
    <AntInputNumber
      controls={{
        upIcon: <UntitledIcon icon={ulChevronUp} color='#6F91B7' size={iconSize} />,
        downIcon: <UntitledIcon icon={ulChevronDown} color='#6F91B7' size={iconSize} />,
      }}
      {...props}
    />
  )
}
